import TextReportGenerator from "../TextReportGenerator";
import ReportData from "../../ReportData";
import { saveClassByClassNameDecorator } from "../../../../shared/utils/classNameToConstructor";
import { DisplayedField } from "../../DisplayedField";

const DEFAULT_VERSION = "1";

const TITLE: string = "ClearVoyage Departure Report";

const FIELDS: DisplayedField[] = [
  { fieldType: "IMONumber", required: true },
  { fieldType: "ReportDate", required: true },
  { fieldType: "Remarks", required: false },
  { fieldType: "ConsumptionItemsEOSP", required: true },
  { fieldType: "ROBItems", required: true },
  { fieldType: "DeparturePort", required: true },
  { fieldType: "Position", required: true },
  { fieldType: "LoadCondition", required: true },
  { fieldType: "DraftMid", required: true },
  { fieldType: "DraftFore", required: true },
  { fieldType: "DraftAft", required: true },
  { fieldType: "Anchorage", required: false },
  { fieldType: "CargoBillOfLadingQuantity", required: false },
];

@saveClassByClassNameDecorator()
class ClearVoyageDepartureReportGenerator extends TextReportGenerator {
  public constructor() {
    super(TITLE, FIELDS, DEFAULT_VERSION);
  }

  getReportText(_data: ReportData, _version: string | undefined): string {
    return "";
  }
}

export default ClearVoyageDepartureReportGenerator;
